import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, Subscriber } from 'rxjs';
import { Router } from '@angular/router';
import { ServerService } from './firebase/server.service';


@Injectable({
  providedIn: 'root'
})

export class RequestService {
  public observer: Subscriber<{}>;

  constructor(private router: Router, private server: ServerService) {
  }

  public sendParcel(parcel: any) {
    return this.server.request('POST', '/deals', parcel
    ).subscribe((response: any) => {
      console.log(response);
    });
  }

  public updateUser(data: any) {
    return this.server.request('PUT', '/accounts/'+data.id, data
    ).subscribe((response: any) => {
      console.log(response);
    });
  }

  public updateCompany(data: any) {
    return this.server.request('PUT', '/companies/mine/', data
    ).subscribe((response: any) => {
      console.log(response);
    });
  }

  public addCourier(userId: any,dealId: any): Observable<string> {
    var subject = new Subject<string>();
    this.server.request('POST', '/deals/'+dealId+'/couriers', {
      courierId: userId,
    }
    ).subscribe((response: any) => {
      console.log(response);
      subject.next(response.httpStatusCode);
    }, error => {
      console.log(error);
      subject.next(error.status);
    });
    return subject.asObservable();
  }


  public addCompany(data: any) {
    return this.server.request('POST', '/companies/', data
    ).subscribe((response: any) => {
      console.log(response);
    });
  }

  public addUser(data: any) {
    return this.server.request('POST', '/accounts/', data
    ).subscribe((response: any) => {
      console.log(response);
    });
  }

  public addPromo(data: any): Observable<string> {
    var subject = new Subject<string>();
    this.server.request('POST', '/promoCodes', data
    ).subscribe((response: any) => {
      console.log(response);
      subject.next(response.httpStatusCode);
    }, error => {
      console.log(error);
      subject.next(error.status);
    });
    return subject.asObservable();
  }

  public getPromo(data: any): Observable<object> {
    var subject = new Subject<object>();
    this.server.get('/promoCodes', data
    ).subscribe((response: any) => {
      console.log(response);
      subject.next(response);
    }, error => {
      console.log(error);
      subject.next(error.status);
    });
    return subject.asObservable();
  }

  public getPromoOne(id: any,data: any): Observable<object> {
    var subject = new Subject<object>();
    this.server.get('/promoCodes/'+id, data
    ).subscribe((response: any) => {
      console.log(response);
      subject.next(response);
    }, error => {
      console.log(error);
      subject.next(error.status);
    });
    return subject.asObservable();
  }

  public editPromo(data: any,id: any): Observable<string> {
    var subject = new Subject<string>();
    this.server.request('PUT', '/promoCodes/'+id, data
    ).subscribe((response: any) => {
      console.log(response);
      subject.next(response.httpStatusCode);
    }, error => {
      console.log(error);
      subject.next(error.status);
    });
    return subject.asObservable();
  }

  public getNotifications(data: any): Observable<object> {
    var subject = new Subject<object>();
    this.server.get('/accounts/me/notifications', data
    ).subscribe((response: any) => {
      console.log(response);
      subject.next(response);
    }, error => {
      console.log(error);
      subject.next(error.status);
    });
    return subject.asObservable();
  }

  public setNotificationsReed(id): Observable<string> {
    var data = {status: "read"};
    var subject = new Subject<string>();
    this.server.request('POST', '/accounts/me/notifications/'+id+'/status', data
    ).subscribe((response: any) => {
      console.log(response);
      subject.next(response.httpStatusCode);
    }, error => {
      console.log(error);
      subject.next(error.status);
    });
    return subject.asObservable();
  }

  public getInvoicesPeriods(data: any): Observable<object> {
    var subject = new Subject<object>();
    this.server.get('/companies/payments-reports', data
    ).subscribe((response: any) => {
      console.log(response);
      subject.next(response);
    }, error => {
      console.log(error);
      subject.next(error.status);
    });
    return subject.asObservable();
  }


  public getOwnInvoicesPeriods(data: any): Observable<object> {
    var subject = new Subject<object>();
    this.server.get('/companies/mine/payments-report', data
    ).subscribe((response: any) => {
      console.log(response);
      subject.next(response);
    }, error => {
      console.log(error);
      subject.next(error.status);
    });
    return subject.asObservable();
  }
}
